import './_team-stats.scss';
import React from 'react';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
library.add(faCaretDown)

class TeamStats extends React.Component {

	render() {
		let bgStyleA = { backgroundImage: `url(${this.props.data?.image})`};
		return (
		<div className="card mb-3 view-head">
			<div className="card-body">
				<div className="row">
				<div className="col-12">
							<div id="teamHeadSelector">

								<div id="image-team" className="image" style={bgStyleA}></div>
								<select className="form-control" id="teamSelector" onChange={this.props.change}>
									{this.props.teams.map((team, index) => {
										if (team.status === 'active') {
											return <option key={'key' + index} value={team.id}>{team.name}</option>
										}
										else {
											return <option key={'key' + index} value={team.id}>Inactive - {team.name} </option>
										}

									})}
								</select><FontAwesomeIcon icon="caret-down" />

							</div>
							<strong>Team Name: </strong>{this.props.data?.fantasyname}<br />
				</div>
				<div className="col-lg-6">
					<p>
						<strong>Founded: </strong>{this.props.stats?.founded}<br />
						<strong>Record: </strong> <span id="Record">{this.props.stats?.wins}-{this.props?.stats?.loses}-{this.props?.stats?.ties}</span> <br />
						<strong>Biggest Winning Streak: </strong> <span id="big-win-streak">{this.props?.stats?.winStreak}</span> <span className="streak-date">({this.props?.stats?.winStart} - {this.props?.stats?.winEnd})</span>
						<strong>Total Points: </strong><span id="total-points">{this.props?.stats?.points?.toFixed(2)}</span><br />	
						<strong>Average Points: </strong><span id="avg-points">{this.props?.stats?.averageScore?.toFixed(2)}</span><br />	
						<strong>Highest Score: </strong><span id="highest-score">{this.props?.stats?.highestScore?.toFixed(2)}</span> <span className="streak-date">({this.props?.stats?.highestScoreDate})</span> 
						<strong>Biggest Win Margin: </strong><span id="big-win-margin">{this.props?.stats?.highestWinMargin?.toFixed(2)}</span> <span className="streak-date">({this.props?.stats?.highestWinMarginDate})</span> 
						<strong>Biggest Loss Margin: </strong><span id="big-loss-margin">-{this.props?.stats?.highestLossMargin?.toFixed(2)}</span> <span className="streak-date">({this.props?.stats?.highestLossMarginDate})</span> 
					</p>
				</div> 
				<div className="col-lg-6">

					<p>
						<strong>Seasons: </strong> {this.props.stats?.seasons} <br />
						<strong>Current Streak: </strong> {this.props?.stats?.currentStreak} <br />
						<strong>Biggest Losing Streak: </strong> <span id="big-loss-streak">{this.props?.stats?.loseStreak}</span> <span className="streak-date">({this.props?.stats?.loseStart} - {this.props?.stats?.loseEnd})</span>
						<strong>Total Points Against: </strong><span id="total-points-against">{this.props?.stats?.pointsAgaisnt?.toFixed(2)}</span><br />	
						<strong>Average Points Against: </strong><span id="avg-points-against">{this.props?.stats?.averageScoreAgaints?.toFixed(2)}</span><br />
						<strong>Lowest Score: </strong><span id="loweset-score">{this.props?.stats?.lowestScore?.toFixed(2)}</span> <span className="streak-date">({this.props?.stats?.lowestScoreDate})</span>
						<strong>Lowest Win Margin: </strong><span id="low-win-game">{this.props?.stats?.lowestWinMargin?.toFixed(2)}</span> <span className="streak-date">({this.props?.stats?.lowestWinMarginDate})</span> 
						<strong>Lowest Loss Margin: </strong><span id="low-loss-game">-{this.props?.stats?.lowestLossMargin?.toFixed(2)}</span> <span className="streak-date">({this.props?.stats?.lowestLossMarginDate})</span> 
						
					</p>
				</div>
				
			</div>
		</div> 
		</div>
	);
	}

}
   
          
          
export default TeamStats;